import { useEffect } from "react";
const SalesIQ = () => {
  useEffect(() => {
    window.$zoho = window.$zoho || {};
    window.$zoho.salesiq = window.$zoho.salesiq || { ready: function () {} };

    if (!document.getElementById("zsiqscript")) {
      const script = document.createElement("script");
      script.id = "zsiqscript";
      script.src =
        "https://salesiq.zohopublic.in/widget?wc=siqc5cd20de22f7119b595cbe090c399d77d64291b434842dfb2658d6af2077b77a";
      script.defer = true;
      document.body.appendChild(script);
      script.onload = () => {
        if (window.$zoho && window.$zoho.salesiq) {
          window.$zoho.salesiq.ready(() => {
            window.$zoho.salesiq.hideTabs(["home", "faq", "articles", "conversations"]);
          });
        }
      };
    }
  }, []);

  return null;
};

export default SalesIQ;
